module.exports = __webpack_public_path__ + "static/media/location-00992b.26c9d974.svg";